export default __webpack_public_path__ + "static/media/valleyPort11.f8d1bb8a.png";